import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// Initialize the echo for socket connection
const echo = new Echo({
  broadcaster: "pusher",
  key: process.env.REACT_APP_PUSHER_APP_KEY,
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  wsHost: process.env.REACT_APP_SOCKET_HOST,
  wsPort: process.env.REACT_APP_SOCKET_PORT,
  forceTLS: process.env.REACT_APP_SOCKET_SCHEME === "https",
  disableStats: true,
  enabledTransports:
    process.env.REACT_APP_SOCKET_SCHEME === "https" ? ["wss"] : ["ws", "wss"],
  authEndpoint: `${process.env.REACT_APP_BASE_URL}/api/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('socket-token')}`,
      Accept: "application/json",
    },
  },
});

export default echo;
